import React from 'react'
import { Helmet } from "react-helmet-async";


const ManageAdmission = () => {
    return (
        <>
            <Helmet>
                <title>Manage Admissions</title>
                <meta name="description" content="Oasis Educational Institute" />
            </Helmet>
            <div style={{ marginTop: '5%', marginBottom: '5%', padding: '20px' }}>
                <h1 className="text-center text-bold text-3xl"> This page is coming soon.</h1>
            </div>
        </>
    )
}

export default ManageAdmission